import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import { MuiTelInput } from 'mui-tel-input';
const onlyCountries = ['RU', 'UA', 'BY', 'KZ', 'UZ', 'GE', 'AM', 'TR', 'HU', 'MD'];
export function PhoneNumberField(props) {
    const { onChange, onComplete, ...rest } = props;
    const _onComplete = useCallback((e) => {
        if (e.key === 'Enter') {
            onComplete?.(e);
        }
    }, [onComplete]);
    return (_jsx(MuiTelInput, { defaultCountry: "RU", variant: "outlined", onlyCountries: onlyCountries, ...rest, onChange: onChange, onKeyDown: _onComplete, focusOnSelectCountry: true }));
}
